import { Share2 } from "lucide-react";
import { toast } from "sonner";
import { track } from "@/lib/analytics";

export default function InviteShare() {
  const share = async () => {
    const url = window.location.origin;
    const text = "A new church is coming to Clay County - Victory Chapel launches January 2027. Plan your visit:";
    track("invite_share_click");
    if (navigator.share) {
      try { await navigator.share({ title: "Victory Chapel - VC Clay", text, url }); } catch { /* dismissed */ }
    } else {
      try {
        await navigator.clipboard.writeText(`${text} ${url}`);
        toast.success("Link copied - send it to a friend!");
      } catch { /* clipboard unavailable */ }
    }
  };

  return (
    <div className="mt-6 border-t border-white/15 pt-6" data-testid="invite-share">
      <p className="text-sm text-white/70">Know someone who should be there? Invite them:</p>
      <button type="button" onClick={share} data-testid="invite-share-btn"
              className="mt-3 inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-2.5 font-display text-xs font-700 text-white transition-colors hover:bg-white/10">
        <Share2 size={14} aria-hidden="true" /> SHARE WITH A FRIEND
      </button>
    </div>
  );
}
